import { __ThemeEnum } from './general';
import { __CategoryHierarchyType, __LocationType, __ProfileType } from './aloEjare';

// you can expand this one and add new fields to it
export interface __AppContextType {
    update: (...e: __AppContextActionType[]) => void;
    profile?: __ProfileType<'detail'>;
    theme: __ThemeEnum;
    locations?: __LocationType<'list'>[];
    parentLocations?: __LocationType<'list'>[];
    categories?: __CategoryHierarchyType[];
    chatDeactivateMessage?: string;
}

// type of update function of global state single argument
// you can expand this one and add a {key, value} per filed you add to global state
export type __AppContextActionType =
    | {
          key: __AppContextActionKeyEnum.profile;
          value?: __ProfileType<'detail'>;
      }
    | {
          key: __AppContextActionKeyEnum.theme;
          value: __ThemeEnum;
      }
    | {
          key: __AppContextActionKeyEnum.location;
          value?: __LocationType<'list'>[];
      }
    | {
          key: __AppContextActionKeyEnum.parentLocations;
          value?: __LocationType<'list'>[];
      }
    | {
          key: __AppContextActionKeyEnum.categories;
          value?: __CategoryHierarchyType[];
      }
    | {
          key: __AppContextActionKeyEnum.chatDeactivateMessage;
          value?: string;
      };

// keys of the update function argument in global state
// you can expand this one and add a unique key per filed you add to global state
export enum __AppContextActionKeyEnum {
    profile = 'CONTEXT_USER_PROFILE',
    theme = 'CONTEXT_THEME',
    location = 'CONTEXT_LOCATION',
    parentLocations = 'CONTEXT_PARENT_LOCATIONS',
    categories = 'CONTEXT_CATEGORIES',
    chatDeactivateMessage = 'CONTEXT_CHAT_DEACTIVATE_MESSAGE',
}
